/**
 * LandscapeGameUI
 * Handles UI panels for landscape view.
 */

// ==================== Imports ====================
import BaseGameUI from '../gameui/BaseGameUI'

export default class LandscapeGameUI extends BaseGameUI {

    // ==================== Construction ====================
    constructor(game) {
        super(game);

        this.topPanel = PARAMS.makeSprite(game, 0, 0, 'gameElements', 'topPanelLandscape.png');
        this.topPanel.anchor.set(0.5, 176 / 2 / 245);
        this.view.add(this.topPanel);

        this.goalCompletedSign = PARAMS.makeSprite(game, 0 * PARAMS.scaleFactor, 300 * PARAMS.scaleFactor, 'gameElements', 'levelCompleteSign.png');
        this.goalCompletedSign.anchor.set(0.5);
        this.view.add(this.goalCompletedSign);

        this.bottomPanel = PARAMS.makeSprite(game, -1 * PARAMS.scaleFactor, 253 * PARAMS.scaleFactor, 'gameElements', 'bottomPanelLandscape.png');
        this.bottomPanel.anchor.set(0.5);
        this.view.add(this.bottomPanel);

        this.bombPanel = PARAMS.makeSprite(game, -1 * PARAMS.scaleFactor, 253 * PARAMS.scaleFactor, 'gameElements', 'bombActivePanelLandscape.png');
        this.bombPanel.anchor.set(0.5);
        this.bombPanel.alpha = 0;
        this.view.add(this.bombPanel);

        this.bombFiller = PARAMS.makeSprite(game, -70 * PARAMS.scaleFactor, 255 * PARAMS.scaleFactor, 'gameElements', 'bombChargeLandscape.png');
        this.bombFiller.alpha = 0;
        this.view.add(this.bombFiller);

        this.widthForFullInficator = this.bombFiller.width;
        this.bombFiller.cropRect = new Phaser.Rectangle(0, 0, 0, this.bombFiller.height);
        this.bombFiller.updateCrop();

        this.view.x = (154 / 2 + 3) * PARAMS.scaleFactor;
        this.view.y = (176 / 2 + 1) * PARAMS.scaleFactor;

        this.levelText = this.addTextElement2(0, -65, 'blue', 'Level ' + game.level, 20);
        this.rightText = this.addTextElement2(0, -30, 'green', '', 30);
        this.wrongText = this.addTextElement2(0, -30, 'red', '', 30);
        this.wordPointsText = this.addTextElement2(0, -8, 'white', '', 17);
        this.scoreText = this.addTextElement2(0, 27, 'white', 'Score:', 20);
        this.totalPointsText = this.addTextElement2(0, 55, 'white', '' + game.score, 30);
        this.timerText = this.addTextElement2(0, 100, 'white', 'Time:', 20);
        this.timeLeftText = this.addTextElement2(0, 128, 'white', '', 20);
        this.goals = this.addTextElement2(0, 20 + 253, 'white', 'Goal', 18);
        this.currentGoals = this.addTextElement2(0, 43 + 253, 'white', 'Lines 0/' + game.goal, 22);
        this.bombCounterText = this.addTextElement2(40, 225, 'blue', 'x 8', 22);

        this.goalCompleteMark = PARAMS.makeSprite(game, 40 * PARAMS.scaleFactor, 255 * PARAMS.scaleFactor, 'flashAnims', 'goalCompleteAnimation/0000');
        this.goalCompleteMark.anchor.set(0.5);
        this.goalCompleteMark.alpha = 0;
        this.view.add(this.goalCompleteMark);

        this.goalCompletedText = this.addTextElement2(0, 10, 'blue', 'Goal completed', 14);
        this.goalCompletedSign.scale.set(0.8);
        this.goalCompletedSign.addChild(this.goalCompletedText);

        this.bombInstructionText = this.addTextElement2(0, 180, 'white', 'Drag Bomb To Use', 14);
        this.bonusBombText = this.addTextElement2(0, 296, 'white', 'Bonus Bomb', 20);
        this.bonusBombText.alpha = 0;

        var frames = window.Phaser.Animation.generateFrameNames('goalCompleteAnimation/', 0, 34, '', 4);
        this.goalCompleteMark.animations.add('show', frames, 20, false);
        this.goalCompleteMark.events.onAnimationComplete.add(function () {
            this.goalCompleteMark.alpha = 0
        }, this);

        // Buttons
        this.buttonExit = this.addButton(-56, 365, 'exitButton', this.onButtonExit);
        this.buttonPause = this.addButton(-19, 365, 'statsButton', this.onButtonPause);
        this.buttonMute = this.addButton(19, 365, 'unmuteButton', this.onButtonUnmute);
        this.buttonUnmute = this.addButton(19, 365, 'muteButton', this.onButtonMute);
        this.buttonHelp = this.addButton(56, 365, 'helpButton', this.onButtonHelp);

        this.currentWordFontSize = 30;
        this.currentWordMaxLength = 130;
    }

    // ==================== Initialization ====================
    init(game) {
        super.init(game);
        this.goalCompletedSign.y = 300 * PARAMS.scaleFactor;
    }
}
